module.exports = __webpack_public_path__ + "static/media/mc-bigtasty.2466c348.png";